// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text[data-v-21fdb6d2]{color:#1a051d}.dashed[data-v-21fdb6d2]{background-image:linear-gradient(90deg,#e2daff 50%,hsla(0,0%,100%,0) 0);background-repeat:repeat-x;background-position:bottom;background-size:12px 1px}", ""]);
// Exports
module.exports = exports;
